import script from "./PreguntaMultipleChoice.vue?vue&type=script&setup=true&lang=js"
export * from "./PreguntaMultipleChoice.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__